<template>
    <SettingsPage title="Starter Copy">
        <template #settingsForms>
            <SettingsForm
                :settingsLoading="settingsLoading"
                form="professionForm"
            >
                <template #form>
                    <form
                        action=""
                        method="POST"
                        id="professionForm"
                        @submit.prevent="saveProfession"
                    >
                        <v-text-field
                            label="Change Starter Copy Field Label"
                            name="professionFieldLabel"
                            v-model="settings.professionFieldLabel"
                            outlined
                        />
                        <v-text-field
                            label="Change Starter Copy Notification Title"
                            name="professionNotificationTitle"
                            v-model="settings.professionNotificationTitle"
                            outlined
                        />
                        <v-textarea
                            label="Change Starter Copy Notification Text"
                            name="professionNotificationText"
                            v-model="settings.professionNotificationText"
                            outlined
                        />
                    </form>
                </template>
            </SettingsForm>
        </template>
    </SettingsPage>
</template>

<script>
import settingsMixin from '@/views/Admin/Config/Settings/Common/settingsMixin';
import SettingsPage from '@/views/Admin/Config/Settings/Common/SettingsPage';
import SettingsForm from '@/views/Admin/Config/Settings/Common/SettingsForm';

export default {
    components: { SettingsForm, SettingsPage },
    mixins: [settingsMixin],
    props: [],

    data() {
        return {
            settingPage: 'profession',
            settingName: 'settingProfession'
        };
    },

    methods: {
        saveProfession() {
            const settings = {
                professionFieldLabel: this.settings.professionFieldLabel,
                professionNotificationTitle: this.settings.professionNotificationTitle,
                professionNotificationText: this.settings.professionNotificationText
            };

            this.saveSettings(this.settingPage, this.setPostData(`${this.settingName}`, settings));
        }
    }
};
</script>
